import React, { useContext } from 'react';
import { Add, Check } from '@material-ui/icons';
import { UserContext } from '../userContext';

//allows to select or remove pillars that user is interested
const PillarsSection = ({ onClick }) => {
  const [state] = useContext(UserContext);
  const { user, pillars } = state;
  const availablePillars = Array.isArray(pillars) ? pillars : [];
  const roleType = user?.role?.type || 'none';
  const prePillarIds =
    roleType === 'mentor' && user?.prePillars
      ? user.prePillars
          .split(',')
          .map((pillarId) => parseInt(pillarId, 10))
          .filter((pillarId) => !Number.isNaN(pillarId))
      : [];
  const userPillars =
    roleType === 'mentor' && prePillarIds.length
      ? availablePillars.filter((pillar) => prePillarIds.includes(pillar.id))
      : Array.isArray(user?.pillars)
      ? user.pillars
      : [];
  const preRegistryPillars = availablePillars.filter((pillar) =>
    prePillarIds.includes(pillar.id)
  );
  const PillarsMentorSelection = () => {
    return availablePillars.map((pillar) => {
      const p = userPillars.some((item) => item.id === pillar.id);
      return (
        <button
          type="button"
          key={pillar.id}
          className={
            p
              ? 'session-overview__pillar-chip is-active'
              : 'session-overview__pillar-chip'
          }
          onClick={() => onClick(pillar)}
          title={pillar.description || pillar.name}
        >
          <span className="session-overview__pillar-check" aria-hidden="true">
            {p ? <Check /> : <Add />}
          </span>
          <span>{pillar.name}</span>
        </button>
      );
    });
  };
  return (
    <div className="session-overview__pillars">
      <div className="session-overview__pillars-header">
        <div>
          <span className="session-overview__label">Pilares asignados</span>
          <strong className="session-overview__pillars-title">
            Designar pilares
          </strong>
        </div>
        <span className="session-overview__pillars-count">
          {userPillars.length}/{availablePillars.length}
        </span>
      </div>
      {user?.preRegistry && !user.active && (
        <div className="session-overview__pre-pillars">
          <span className="session-overview__pre-pillars-label">
            Postulación
          </span>
          <div className="session-overview__pre-pillars-list">
            {preRegistryPillars.map((pillar) => (
              <span
                key={pillar.id}
                className="session-overview__pre-pillar-chip"
              >
                {pillar.name}
              </span>
            ))}
          </div>
        </div>
      )}
      <div className="session-overview__pillar-list">
        <PillarsMentorSelection />
      </div>
    </div>
  );
};
export default PillarsSection;
